var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverMobileDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 428,
    height: 639,
    viewBox: "0 0 428 639",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_306_175645)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_306_175645)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_306_175645)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4066 595.817C94.4066 595.817 90.1978 606.56 93.2596 608.413C106.93 616.687 147.916 623.502 188.892 625.02C246.164 627.14 309.376 624.716 336.056 614.139C338.444 613.193 341.586 609.269 342.358 606.694C343.938 601.414 341.211 596.389 341.211 596.389C341.211 596.389 265.431 603.258 197.497 603.258C142.578 603.258 94.4066 595.817 94.4066 595.817Z",
    fill: "url(#paint0_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.731 642.346H517.716L298.463 538L165.697 579.726L68.5887 642.346H-179.999H142.179L154.191 623.632L285.819 625.246L294.164 641.936L584.731 642.346Z",
    fill: "url(#paint1_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2998 644.369L199.836 558.387",
    stroke: "#070B36",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M323.751 550.295L517.968 642.852L323.751 550.295Z",
    fill: "#070B36",
    stroke: "#070B36",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M264.575 563.951L307.06 642.851L264.575 563.951Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.101 595.289L473.208 620.947L465.621 624.623L450.448 624.118H332.097L420.101 595.289Z",
    fill: "url(#paint2_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.513 568.599L129.028 647.5",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.683 566.04C320.675 560.72 133.918 568.767 74.9373 568.901C54.4067 568.95 93.8343 596.39 93.8343 596.39L92.6918 607.842C92.6918 607.842 100.784 622.191 210.654 625.021C262.212 626.36 312.972 623.762 331.481 616.429C342.639 612.015 342.933 605.552 342.933 605.552L341.215 595.818C341.215 595.818 351.48 589.958 355.533 584.937C362.491 576.35 364.45 566.54 360.683 566.04Z",
    fill: "url(#paint3_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.683 566.04C320.675 560.72 133.918 568.767 74.9373 568.901C54.4067 568.95 93.8343 596.39 93.8343 596.39L92.6918 607.842C92.6918 607.842 100.784 622.191 210.654 625.021C262.212 626.36 312.972 623.762 331.481 616.429C342.639 612.015 342.933 605.552 342.933 605.552L341.215 595.818C341.215 595.818 351.48 589.958 355.533 584.937C362.491 576.35 364.45 566.54 360.683 566.04Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.811 602.315C139.172 602.409 93.5137 596.067 93.5137 596.067C93.5137 596.067 138.726 604.194 190.365 604.101C259.361 603.976 330.508 596.96 330.508 596.96C330.508 596.96 259.807 602.19 190.811 602.315Z",
    fill: "#000204"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.811 602.315C139.172 602.409 93.5137 596.067 93.5137 596.067C93.5137 596.067 138.726 604.194 190.365 604.101C259.361 603.976 330.508 596.96 330.508 596.96C330.508 596.96 259.807 602.19 190.811 602.315Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.108 553.744C149.324 553.244 70.0763 561.376 69.2417 567.785C67.9295 577.85 134.716 579.483 215.487 579.483C296.257 579.483 358.522 573.976 361.727 568.37C367.302 558.631 336.439 554.4 230.108 553.744Z",
    fill: "url(#paint4_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.108 553.744C149.324 553.244 70.0763 561.376 69.2417 567.785C67.9295 577.85 134.716 579.483 215.487 579.483C296.257 579.483 358.522 573.976 361.727 568.37C367.301 558.631 336.439 554.4 230.108 553.744Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0826 569.735C101.766 569.735 105.563 568.436 105.563 566.834C105.563 565.231 101.766 563.933 97.0826 563.933C92.3992 563.933 88.6025 565.231 88.6025 566.834C88.6025 568.436 92.3992 569.735 97.0826 569.735Z",
    fill: "url(#paint5_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.0826 569.735C101.766 569.735 105.563 568.436 105.563 566.834C105.563 565.231 101.766 563.933 97.0826 563.933C92.3992 563.933 88.6025 565.231 88.6025 566.834C88.6025 568.436 92.3992 569.735 97.0826 569.735Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.072 576.875C151.755 576.875 155.552 575.577 155.552 573.974C155.552 572.372 151.755 571.073 147.072 571.073C142.388 571.073 138.592 572.372 138.592 573.974C138.592 575.577 142.388 576.875 147.072 576.875Z",
    fill: "url(#paint6_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.072 576.875C151.755 576.875 155.552 575.577 155.552 573.974C155.552 572.372 151.755 571.073 147.072 571.073C142.388 571.073 138.592 572.372 138.592 573.974C138.592 575.577 142.388 576.875 147.072 576.875Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.819 573.751C303.502 573.751 307.299 572.452 307.299 570.85C307.299 569.248 303.502 567.949 298.819 567.949C294.136 567.949 290.339 569.248 290.339 570.85C290.339 572.452 294.136 573.751 298.819 573.751Z",
    fill: "url(#paint7_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.819 573.751C303.502 573.751 307.299 572.452 307.299 570.85C307.299 569.248 303.502 567.949 298.819 567.949C294.136 567.949 290.339 569.248 290.339 570.85C290.339 572.452 294.136 573.751 298.819 573.751Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.369 577.322C249.052 577.322 252.849 576.023 252.849 574.421C252.849 572.818 249.052 571.52 244.369 571.52C239.685 571.52 235.889 572.818 235.889 574.421C235.889 576.023 239.685 577.322 244.369 577.322Z",
    fill: "url(#paint8_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.369 577.322C249.052 577.322 252.849 576.023 252.849 574.421C252.849 572.818 249.052 571.52 244.369 571.52C239.685 571.52 235.889 572.818 235.889 574.421C235.889 576.023 239.685 577.322 244.369 577.322Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.951 578.214C202.634 578.214 206.431 576.915 206.431 575.313C206.431 573.711 202.634 572.412 197.951 572.412C193.267 572.412 189.471 573.711 189.471 575.313C189.471 576.915 193.267 578.214 197.951 578.214Z",
    fill: "url(#paint9_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.951 578.214C202.634 578.214 206.431 576.915 206.431 575.313C206.431 573.711 202.634 572.412 197.951 572.412C193.267 572.412 189.471 573.711 189.471 575.313C189.471 576.915 193.267 578.214 197.951 578.214Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.203 566.61C341.886 566.61 345.683 565.311 345.683 563.709C345.683 562.106 341.886 560.808 337.203 560.808C332.519 560.808 328.723 562.106 328.723 563.709C328.723 565.311 332.519 566.61 337.203 566.61Z",
    fill: "url(#paint10_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.203 566.61C341.886 566.61 345.683 565.311 345.683 563.709C345.683 562.106 341.886 560.808 337.203 560.808C332.519 560.808 328.723 562.106 328.723 563.709C328.723 565.311 332.519 566.61 337.203 566.61Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.533 517.363L167.704 526.526C167.704 526.526 193.144 527.812 219.245 527.673C246.917 527.526 275.36 525.955 275.36 525.955L283.394 517.363H154.533Z",
    fill: "url(#paint11_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.533 517.363L167.704 526.526C167.704 526.526 193.144 527.812 219.245 527.673C246.917 527.526 275.36 525.955 275.36 525.955L283.394 517.363H154.533Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.389 543.134C284.595 536.613 281.342 530.299 277.655 524.237L163.697 523.662L147.665 567.182C147.665 567.182 184.067 570.016 220.964 569.476C269.318 568.762 294.258 564.321 294.258 564.321C292.461 557.108 290.166 550.029 287.389 543.134Z",
    fill: "url(#paint12_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.389 543.134C284.595 536.613 281.342 530.299 277.655 524.237L163.697 523.662L147.665 567.182C147.665 567.182 184.067 570.016 220.964 569.476C269.318 568.762 294.258 564.321 294.258 564.321C292.461 557.108 290.166 550.029 287.389 543.134V543.134Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.519 545.995C182.772 545.995 156.252 543.705 156.252 543.705V544.294C175.063 546.54 193.989 547.687 212.934 547.731C247.671 547.731 287.38 544.294 287.38 544.294V543.723C287.38 543.723 248.109 545.995 213.519 545.995Z",
    fill: "#000912"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.519 545.995C182.772 545.995 156.252 543.705 156.252 543.705V544.294C175.063 546.54 193.989 547.687 212.934 547.731C247.671 547.731 287.38 544.294 287.38 544.294V543.723C287.38 543.723 248.109 545.995 213.519 545.995Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.959 519.082C254.538 519.082 283.38 518.057 283.38 516.792C283.38 515.528 254.538 514.502 218.959 514.502C183.38 514.502 154.537 515.528 154.537 516.792C154.537 518.057 183.38 519.082 218.959 519.082Z",
    fill: "url(#paint13_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.963 518.51C153.071 519.282 150.683 521.37 147.434 524.053C150.487 521.531 145.675 530.699 134.491 538.549C126.506 544.159 117.49 540.049 117.312 550.002C117.272 552.108 113.581 564.284 115.593 566.038C123.627 572.969 148.804 566.609 148.804 566.609C148.804 566.609 155.601 552.202 156.838 544.293C163.086 536.871 167.714 526.543 167.714 526.543C167.714 526.543 156.864 515.957 153.963 518.51Z",
    fill: "url(#paint14_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.963 518.51C153.071 519.282 150.683 521.37 147.434 524.053C150.487 521.531 145.675 530.699 134.491 538.549C126.506 544.159 117.49 540.049 117.312 550.002C117.272 552.108 113.581 564.284 115.593 566.038C123.627 572.969 148.804 566.609 148.804 566.609C148.804 566.609 155.601 552.202 156.838 544.293C163.086 536.871 167.714 526.543 167.714 526.543C167.714 526.543 156.864 515.957 153.963 518.51Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.903 542.558C314.194 538.719 306.219 536.452 300.006 531.681C293.539 526.709 291.816 520.282 283.974 517.934C282.046 517.359 281.296 519.362 279.957 520.8C278.038 522.875 275.94 524.816 275.94 524.816C276.379 526.661 277.155 528.409 278.23 529.971C280.462 533.381 284.371 537.867 286.817 543.142C288.125 545.963 287.54 548.994 288.536 551.729C290.133 556.064 292.047 560.275 294.262 564.329C294.262 564.329 324.5 563.601 324.04 562.611C323.085 560.553 324.477 547.119 318.903 542.558Z",
    fill: "url(#paint15_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.903 542.558C314.194 538.719 306.219 536.452 300.006 531.681C293.539 526.709 291.816 520.282 283.974 517.934C282.046 517.359 281.296 519.362 279.957 520.8C278.038 522.875 275.94 524.816 275.94 524.816C276.379 526.661 277.155 528.409 278.23 529.971C280.462 533.381 284.371 537.867 286.817 543.142C288.125 545.963 287.54 548.994 288.536 551.729C290.133 556.064 292.047 560.275 294.262 564.329C294.262 564.329 324.5 563.601 324.04 562.611C323.085 560.553 324.477 547.119 318.903 542.558Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.254 210.448C126.809 209.466 116.745 226.48 116.745 226.48C116.745 226.48 112.657 235.495 125.903 246.524C129.791 249.76 125.85 255.16 133.937 256.829C148.858 259.9 194.337 244.551 212.373 245.359C245.999 246.872 286.6 257.905 307.439 254.522C318.641 252.706 320.609 235.625 320.609 235.625C320.609 235.625 313.178 211.341 223.254 210.448Z",
    fill: "url(#paint16_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.254 210.448C126.809 209.466 116.745 226.48 116.745 226.48C116.745 226.48 112.657 235.495 125.903 246.524C129.791 249.76 125.85 255.16 133.937 256.829C148.858 259.9 194.337 244.551 212.373 245.359C245.999 246.872 286.6 257.905 307.439 254.522C318.641 252.706 320.609 235.625 320.609 235.625C320.609 235.625 313.178 211.341 223.254 210.448Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.244 235.627C124.687 233.431 128.195 255.671 128.195 255.671C128.195 255.671 137.939 275.443 224.395 275.71C305.04 275.96 310.293 257.96 310.293 257.96C310.293 257.96 316.818 237.894 219.244 235.627Z",
    fill: "url(#paint17_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.244 235.627C124.687 233.431 128.195 255.671 128.195 255.671C128.195 255.671 137.939 275.443 224.395 275.71C305.04 275.96 310.293 257.96 310.293 257.96C310.293 257.96 316.818 237.894 219.244 235.627Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.803 243.07C140.768 243.288 147.659 260.82 147.659 260.82C147.659 260.82 154.907 274.633 216.392 275.709C291.454 277.025 290.838 261.395 290.838 261.395C290.838 261.395 295.694 242.837 215.803 243.07Z",
    fill: "url(#paint18_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.803 243.07C140.768 243.288 147.659 260.82 147.659 260.82C147.659 260.82 154.907 274.633 216.392 275.709C291.454 277.025 290.838 261.395 290.838 261.395C290.838 261.395 295.694 242.837 215.803 243.07Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.538 262.538C284.302 262.23 285.788 248.113 212.958 248.224C151.317 248.318 153.406 262.538 153.406 262.538L163.14 275.137C163.14 275.137 229.195 282.368 265.07 278.574C281.695 276.815 285.239 263.462 284.538 262.538Z",
    fill: "url(#paint19_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.538 262.538C284.302 262.23 285.788 248.113 212.958 248.224C151.317 248.318 153.406 262.538 153.406 262.538L163.14 275.137C163.14 275.137 229.195 282.368 265.07 278.574C281.695 276.815 285.239 263.462 284.538 262.538Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.664 284.873C275.862 264.874 157.213 266.632 157.971 282.584C158.73 298.535 285.208 302.088 281.664 284.873Z",
    fill: "url(#paint20_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.664 284.873C275.862 264.874 157.213 266.632 157.971 282.584C158.73 298.535 285.208 302.088 281.664 284.873Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.944 284.873L275.86 285.145C275.86 285.145 267.451 323.528 269.063 323.238C269.362 323.189 280.52 316.94 280.52 316.94L279.944 284.873Z",
    fill: "url(#paint21_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.944 284.873L275.86 285.145C275.86 285.145 267.451 323.528 269.063 323.238C269.362 323.189 280.52 316.94 280.52 316.94L279.944 284.873Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.663 279.146C281.663 278.7 276.263 264.842 214.662 265.976C162.291 266.944 157.979 277.428 157.979 277.428V283.154C157.979 283.154 263.855 286.506 280.525 284.873C281.958 284.734 281.663 279.28 281.663 279.146Z",
    fill: "url(#paint22_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.663 279.146C281.663 278.7 276.263 264.842 214.662 265.976C162.291 266.944 157.979 277.428 157.979 277.428V283.154C157.979 283.154 263.855 286.506 280.525 284.873C281.958 284.734 281.663 279.28 281.663 279.146Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.587 275.138C245.587 274.911 230.046 272.643 223.824 272.277L220.388 273.42V282.583C220.388 282.583 221.379 283.475 221.535 285.444C221.936 290.527 223.253 300.333 223.253 300.333L234.683 306.358L243.868 300.909C243.868 300.909 242.181 285.136 245.587 283.73C247.158 283.078 245.587 275.571 245.587 275.138Z",
    fill: "url(#paint23_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.587 275.138C245.587 274.911 230.046 272.643 223.824 272.277L220.388 273.42V282.583C220.388 282.583 221.379 283.475 221.535 285.444C221.936 290.527 223.253 300.333 223.253 300.333L234.683 306.358L243.868 300.909C243.868 300.909 242.181 285.136 245.587 283.73C247.158 283.078 245.587 275.571 245.587 275.138Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.851 283.729V290.026L169.422 306.058L166.562 313.503L172.288 314.078L175.724 306.045L176.296 290.013V283.729C176.296 283.269 168.851 283.729 168.851 283.729Z",
    fill: "url(#paint24_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.851 283.729V290.026L169.422 306.058L166.562 313.503L172.288 314.078L175.724 306.045L176.296 290.013V283.729C176.296 283.269 168.851 283.729 168.851 283.729Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.738 273.42L226.115 271.13L223.825 272.273V281.436L226.115 282.583L227.262 297.472L234.706 306.059L249.02 298.615V283.73L251.314 280.865L250.738 273.42Z",
    fill: "url(#paint25_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.738 273.42L226.115 271.13L223.825 272.273V281.436L226.115 282.583L227.262 297.472L234.706 306.059L249.02 298.615V283.73L251.314 280.865L250.738 273.42Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.063 285.443L268.492 318.658V321.524L275.937 316.003V285.216L269.063 285.443Z",
    fill: "url(#paint26_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.063 285.443L268.492 318.658V321.524L275.937 316.003V285.216L269.063 285.443Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.554 283.153C162.081 282.68 162.554 309.486 162.554 309.486L166.571 313.503C168.419 311.41 169.614 308.822 170.008 306.058C170.976 297.761 171.15 283.742 171.15 283.742C171.15 283.742 162.728 283.332 162.554 283.153Z",
    fill: "url(#paint27_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.554 283.153C162.081 282.68 162.554 309.486 162.554 309.486L166.571 313.503C168.419 311.41 169.614 308.822 170.008 306.058C170.976 297.761 171.15 283.742 171.15 283.742C171.15 283.742 162.728 283.332 162.554 283.153Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.705 500.757L163.688 495.03C163.688 495.03 159.466 500.449 159.671 500.757C159.876 501.064 158.97 517.859 159.671 517.935C160.523 518.029 166.401 520.225 167.705 517.364C169.994 512.289 167.705 500.757 167.705 500.757Z",
    fill: "url(#paint28_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.705 500.757L163.688 495.03C163.688 495.03 159.466 500.449 159.671 500.757C159.876 501.064 158.97 517.859 159.671 517.935C160.523 518.029 166.401 520.225 167.705 517.364C169.994 512.289 167.705 500.757 167.705 500.757Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.704 500.756V517.935L175.149 517.363V500.756H167.704Z",
    fill: "url(#paint29_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.704 500.756V517.935L175.149 517.363V500.756H167.704Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.717 495.03H163.684C163.684 495.03 166.763 502.475 167.7 502.475C169.089 502.475 174.44 504.037 175.145 501.904C175.636 500.444 171.717 495.03 171.717 495.03Z",
    fill: "url(#paint30_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.717 495.03H163.684C163.684 495.03 166.763 502.475 167.7 502.475C169.089 502.475 174.44 504.037 175.145 501.904C175.636 500.444 171.717 495.03 171.717 495.03Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.361 495.03H268.492L269.063 517.935H275.937L275.361 495.03Z",
    fill: "url(#paint31_linear_306_175645)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.361 495.03H268.492L269.063 517.935H275.937L275.361 495.03Z",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.314 236.782L223.837 221.884L117.314 236.782Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.84 257.96C231.84 257.96 204.825 257.96 183.192 260.249C174.05 261.253 165.033 263.171 156.274 265.976C165.292 263.164 174.558 261.221 183.946 260.173C205.494 257.893 231.84 257.96 231.84 257.96Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.594 260.249L180.305 249.944L182.594 260.249Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.104 278.257L239.286 278.574M231.649 290.201L248.65 290.518",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.741 283.422L166.562 313.504",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M222.111 499.036C222.111 499.036 227.466 493.31 232.992 493.31C238.053 493.31 243.297 499.036 243.297 499.036V515.073C243.297 515.073 246.305 517.75 245.016 517.933C240.146 518.683 224.307 517.933 220.392 517.933C219.388 517.933 222.111 515.073 222.111 515.073V499.036Z",
    fill: "url(#paint32_linear_306_175645)",
    stroke: "black",
    strokeWidth: 0.446318
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.459 272.572V282.837",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.318 248.471V265.877M224.061 210.98V222.138M168.271 229.725V237.313",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.872 277.928V302.922",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M232.988 518.381L231.841 493.187L232.988 518.381Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.069 542.063L226.038 523.983L226.069 542.063Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M233.211 506.442L243.923 505.996L233.211 506.442Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M273.071 512.852L271.929 495.098L273.071 512.852Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.031 512.16L163.46 495.552L164.031 512.16Z",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.567 568.9L236.996 559.737",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.832 559.555L248.609 553.307L248.386 547.058",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.606 560.447L221.383 554.199L221.16 547.95",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M220.963 554.586L154.533 551.721L220.963 554.586Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.002 537.18L226.069 537.6",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.386 559.554L221.16 560.001",
    stroke: "black",
    strokeWidth: 0.892635,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.317 600.46V623.22L142.178 642.187L132.568 641.681L154.317 600.46Z",
    fill: "#061833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.026 598.438L285.566 625.496L294.67 642.946H307.062L282.026 598.438Z",
    fill: "#061833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.685 622.208L153.366 601.232",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.86 617.362L130.18 601.025",
    stroke: "black",
    strokeWidth: 0.787854
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.569 622.967L153.811 599.973",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.817 625.243L283.289 598.961",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.824 599.097L305.504 638.498",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.096 597.159L326.373 626.421",
    stroke: "black",
    strokeWidth: 1.01155
  }), /*#__PURE__*/React.createElement("line", {
    x1: 325.761,
    y1: 626.255,
    x2: 473.953,
    y2: 622.714,
    stroke: "black",
    strokeWidth: 1.01155
  }))), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -8,
    width: 484,
    height: 405,
    fill: "url(#paint33_linear_306_175645)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_306_175645",
    x1: 217.501,
    y1: 625.721,
    x2: 217.501,
    y2: 595.817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#000912",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000912"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_306_175645",
    x1: -645.508,
    y1: 393.226,
    x2: 719.973,
    y2: 188.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4254B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.546875,
    stopColor: "#081743"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#001E40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_306_175645",
    x1: 332.097,
    y1: 606.163,
    x2: 509.623,
    y2: 606.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#010E1E",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010E1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_306_175645",
    x1: 69.0102,
    y1: 594.787,
    x2: 362.571,
    y2: 594.787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_306_175645",
    x1: 70.2637,
    y1: 580.095,
    x2: 361.343,
    y2: 554.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08112B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08112B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_306_175645",
    x1: 88.665,
    y1: 567.57,
    x2: 105.5,
    y2: 566.097,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_306_175645",
    x1: 138.592,
    y1: 573.974,
    x2: 155.552,
    y2: 573.974,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_306_175645",
    x1: 290.339,
    y1: 570.85,
    x2: 307.299,
    y2: 570.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_306_175645",
    x1: 235.889,
    y1: 574.421,
    x2: 252.849,
    y2: 574.421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_306_175645",
    x1: 189.471,
    y1: 575.313,
    x2: 206.431,
    y2: 575.313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_306_175645",
    x1: 328.723,
    y1: 563.709,
    x2: 345.683,
    y2: 563.709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#051535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021326"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_306_175645",
    x1: 220.834,
    y1: 532.65,
    x2: 218,
    y2: 509.571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_306_175645",
    x1: 147.665,
    y1: 546.602,
    x2: 294.258,
    y2: 546.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_306_175645",
    x1: 154.533,
    y1: 516.792,
    x2: 283.38,
    y2: 516.792,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#08112B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#08112B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_306_175645",
    x1: 141.35,
    y1: 569.274,
    x2: 141.35,
    y2: 518.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#041532"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010913"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_306_175645",
    x1: 274.16,
    y1: 539.273,
    x2: 326.124,
    y2: 545.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#010913"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041532"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_306_175645",
    x1: 124.279,
    y1: 262.145,
    x2: 314.08,
    y2: 211.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_306_175645",
    x1: 128.405,
    y1: 250.944,
    x2: 310.217,
    y2: 260.473,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_306_175645",
    x1: 147.498,
    y1: 259.427,
    x2: 290.878,
    y2: 259.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0D1A40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#03152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_306_175645",
    x1: 158.422,
    y1: 281.305,
    x2: 280.803,
    y2: 248.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_306_175645",
    x1: 162.368,
    y1: 299.258,
    x2: 277.268,
    y2: 268.471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#03152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_306_175645",
    x1: 268.857,
    y1: 304.06,
    x2: 280.515,
    y2: 304.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_306_175645",
    x1: 161.175,
    y1: 295.102,
    x2: 277.584,
    y2: 263.909,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_306_175645",
    x1: 220.901,
    y1: 291.554,
    x2: 248.037,
    y2: 284.283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_306_175645",
    x1: 166.562,
    y1: 298.801,
    x2: 176.296,
    y2: 298.801,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_306_175645",
    x1: 223.825,
    y1: 288.595,
    x2: 251.314,
    y2: 288.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17244D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_306_175645",
    x1: 272.214,
    y1: 321.519,
    x2: 272.214,
    y2: 285.216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_306_175645",
    x1: 166.74,
    y1: 313.503,
    x2: 166.74,
    y2: 283.149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04152B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#17244D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_306_175645",
    x1: 159.421,
    y1: 506.929,
    x2: 168.722,
    y2: 506.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_306_175645",
    x1: 167.704,
    y1: 509.347,
    x2: 175.149,
    y2: 509.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_306_175645",
    x1: 163.697,
    y1: 499.029,
    x2: 175.194,
    y2: 499.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_306_175645",
    x1: 268.492,
    y1: 506.483,
    x2: 275.937,
    y2: 506.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_306_175645",
    x1: 220.226,
    y1: 505.788,
    x2: 245.337,
    y2: 505.788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0E1B5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#0C1A54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#04152B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_306_175645",
    x1: 241,
    y1: -8,
    x2: 241,
    y2: 397,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#04183C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#041736",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_306_175645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 428,
    height: 639,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_306_175645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 674.832,
    height: 503,
    fill: "white",
    transform: "translate(-135 136)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_306_175645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 691.841,
    height: 508.213,
    fill: "white",
    transform: "translate(-142.14 136)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverMobileDark);
export default __webpack_public_path__ + "static/media/over-mobile-dark.fad6df8bf63dd800d69386dfb0634d52.svg";
export { ForwardRef as ReactComponent };